import { BlobConverter, BlobEncoding } from '@tencent/memoire-blob-storage/lib/utils/blob-converter';
import { CDNImage, uploadImageBlob } from './cgi-upload';
import ImageCompressor, { ImageCompressOptions } from './image-compressor';
import ImageDetector from './image-detector';

const MAX_IMAGE_HEIGHT = 4096;

/**
 * 图片上传通用组件
 */
export default class ImageUploader {
    /**
     * 上传图片
     * @param blob 待上传的图片 Blob
     */
    public static uploadBlob = async (
        file: Blob,
        compressOptions: ImageCompressOptions = { maxHeight: MAX_IMAGE_HEIGHT },
    ): Promise<CDNImage> => {
        const fileInfo = {
            name: (file as File)?.name,
            lastModified: (file as File)?.lastModified,
        };
        if (ImageDetector.isSVG(file)) {
            const dataURL = await BlobConverter.convertBlob(file, BlobEncoding.DataURL);
            return uploadImageBlob({
                blob: new Blob([dataURL]),
                fileInfo,
                extraParams: { base64: true },
            });
        }

        const compressed = await ImageCompressor.compressBlob(file, compressOptions).catch(() => ({ blob: file }));
        return uploadImageBlob({
            blob: compressed.blob,
            fileInfo,
        });
    };
}
